import { TableData, TableColumn } from '@/components/elements/Table';
import Typography from '@/components/elements/Typography';
import clsx from 'clsx';
import { HTMLAttributes } from 'react';

export type TableBodyProps<TableRowData extends Record<string, unknown>> = {
  data: TableData<TableRowData>[];
  columns: TableColumn<TableRowData>[];
  disableLastBorder?: boolean;
} & HTMLAttributes<HTMLElement>;

/**
 * @component TableBody
 */
function TableBody<TableRowData extends Record<string, unknown>>({
  columns,
  data,
  disableLastBorder,
  ...rest
}: TableBodyProps<TableRowData>) {
  return (
    <tbody data-testid="table-body" {...rest}>
      {data.map((row, index) => (
        <tr
          data-testid="table-body_row"
          // eslint-disable-next-line no-underscore-dangle
          key={row.__id}
          className={clsx({
            'children:border-none':
              index === data.length - 1 && disableLastBorder,
          })}
        >
          {columns.map((column) => {
            if (row[column.field] === undefined) return null;

            return (
              <Typography
                data-testid="table-body_cell"
                key={column.field as string}
                variant="bodyLight"
                as="td"
                className="border-b p-3 text-gray-400 border-collapse whitespace-nowrap"
              >
                {typeof column.render === `function`
                  ? column.render(row)
                  : (row[column.field as any] as any)}
              </Typography>
            );
          })}
        </tr>
      ))}
    </tbody>
  );
}

export default TableBody;
